import { Component, OnInit } from '@angular/core';
import { FooterLogoComponent } from '../../includes/footer-logo/footer-logo.component';
import { RouterLink, ActivatedRoute, Router } from '@angular/router';
import { FacebookLogoComponent } from "../../includes/facebook-logo/facebook-logo.component";
import { LinkedinLogoComponent } from "../../includes/linkedin-logo/linkedin-logo.component";

@Component({
  selector: 'pc-footer',
  standalone: true,
  imports: [
    FooterLogoComponent,
    RouterLink,
    FacebookLogoComponent,
    LinkedinLogoComponent
],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})

export class FooterComponent implements OnInit {

  constructor(
    private route: ActivatedRoute, 
    private router: Router
  ) { }

  ngOnInit(): void {

    // this.route.fragment.subscribe(fragment => {
    //   if (fragment) {

    //     console.log(fragment)
    //     // const element = document.getElementById(fragment);
    //     // if (element) {
    //     //   element.scrollIntoView({ behavior: 'smooth' });
    //     // }
    //   }
    // });

  }
}
